import { isMobile } from "../../common/utils.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// reduced horizontal factor for lazy image loading in covers carousel
	if (isMobile()) {
		window.lazySizesConfig = window.lazySizesConfig || {};
		window.lazySizesConfig.hFac = 0.4;
	}
	const chart_toggle_elements = document.querySelectorAll("._chart_toggle");
	function toggle_chart(chart_id) {
		for (const el of document.querySelectorAll("._chart")) {
			if (el.id === chart_id) {
				el.classList.remove("d-none");
			} else {
				el.classList.add("d-none");
			}
		}
		for (const el of chart_toggle_elements) {
			if (el.dataset.chart === chart_id) {
				el.classList.add("active");
			} else {
				el.classList.remove("active");
			}
		}
	}

	for (const el of chart_toggle_elements) {
		el.addEventListener("click", function (e) {
			e.preventDefault();
			toggle_chart(this.dataset.chart);
		});
	}
});
